import {
    AccrualImporterDocumentRow,
    AccrualImporterSort,
} from "./accrualImporter.types";
import {
    accrualDocumentBeingProcessed,
    accrualDocumentNeedsAttention,
    getAccrualImporterFileName,
} from "./accrualImporter.helpers";
import { compareUploadsThenNewest } from "./accrualImporterDraftsSort";

function compareStrings(
    a: string | null | undefined,
    b: string | null | undefined,
    asc: boolean,
): number {
    const aEmpty = !a;
    const bEmpty = !b;

    if (aEmpty && bEmpty) {
        return 0;
    }
    if (aEmpty) {
        return 1;
    }
    if (bEmpty) {
        return -1;
    }

    const cmp = a.localeCompare(b);
    return asc ? cmp : -cmp;
}

function getStatusSortRank(row: AccrualImporterDocumentRow): number {
    if (!row.financialDocument) {
        return 0;
    }

    if (accrualDocumentBeingProcessed(row.financialDocument)) {
        return 1;
    }

    if (accrualDocumentNeedsAttention(row.financialDocument)) {
        return 2;
    }

    return 3;
}

export function sortAccrualImporterDocumentRows({
    rows,
    sort,
}: {
    rows: AccrualImporterDocumentRow[];
    sort: AccrualImporterSort | undefined;
}): AccrualImporterDocumentRow[] {
    if (!sort) {
        return [...rows].sort(compareUploadsThenNewest);
    }

    const sortedRows = [...rows];

    sortedRows.sort((leftRow, rightRow) => {
        switch (sort) {
            case AccrualImporterSort.FILE_NAME_ASC:
                return compareStrings(
                    getAccrualImporterFileName(leftRow),
                    getAccrualImporterFileName(rightRow),
                    true,
                );
            case AccrualImporterSort.FILE_NAME_DESC:
                return compareStrings(
                    getAccrualImporterFileName(leftRow),
                    getAccrualImporterFileName(rightRow),
                    false,
                );
            case AccrualImporterSort.STATUS_ASC:
                return getStatusSortRank(leftRow) - getStatusSortRank(rightRow);
            case AccrualImporterSort.STATUS_DESC:
                return getStatusSortRank(rightRow) - getStatusSortRank(leftRow);
            default:
                return 0;
        }
    });

    return sortedRows;
}
